<script>

export default {
  name: "InputGroupComponent",
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    type: {
      type: String,
      required: true
    },
    validationError: {
      type: Array,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: String
    },
  },
  computed: {
    errMessage() {
      return this.validationError?.length ? this.validationError[0] : null
    }
  }
}
</script>

<template>
  <div :class="['mb-3']">
    <label v-if="label" :class="['col-form-label', { 'required': required }]" :for="label">{{ label }}</label>
    <input
        :type="type"
        :id="label"
        class="form-control"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :disabled="disabled"
        autocomplete="off"
    />
    <slot></slot>
    <small class="has_error" v-if="validationError">{{ errMessage }}</small>
  </div>
</template>

<style scoped>
.has_error{
  color: red;
}
</style>